export default function writeRoomCoords() {
  this.write(this.room.coords);
}